import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { PokeType } from './poke-type.interface';
import { PokeTypeService } from './poke-type.service';
const service = new PokeTypeService();

export interface PokeTypeState {
   pokeTypes: Array<PokeType>;
}

const PokeTypeStore: Module<PokeTypeState, StoreState> = {
   namespaced: true,
   state: {
      pokeTypes: [],
   },
   getters: {},
   mutations: {
      SET_POKE_TYPES(state, pokeTypes: Array<PokeType>) {
         state.pokeTypes = pokeTypes;
      },
   },
   actions: {
      async getPokeTypes(context) {
         const response = await service.getPokeTypes();
         context.commit('SET_POKE_TYPES', response.data);
         return response.data;
      },
   },
};

export default PokeTypeStore;
